import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getCookie } from "../utils/cookieUtils";

/**
 * Canonical hook to resolve auth session and tenant context.
 * Eliminates repetitive `|| ... || ... ||` chains across all UI components.
 */
export function useAuthSession() {
  const reduxCompanyCode = useSelector((state) => state.executor?.companyInfo?.companyCode);
  const userInfo = useSelector((state) => state.session?.settings?.userInfo);

  const companyCode = reduxCompanyCode || userInfo?.companyCode || getCookie("companyCode") || "";
  const role = userInfo?.role || getCookie("role") || "company_admin";
  const isEmployee = role === "employee" || role === "sales_rep";
  const isAdmin = role === "admin" || role === "company_admin" || role === "superadmin";
  const employeeId = isEmployee ? (userInfo?.id || userInfo?._id || userInfo?.employeeId || getCookie("userId")) : null;

  return useMemo(
    () => ({
      companyCode,
      role,
      isEmployee,
      isAdmin,
      employeeId,
      user: userInfo || null,
    }),
    [companyCode, role, isEmployee, isAdmin, employeeId, userInfo]
  );
}

export default useAuthSession;
